import { jsx } from "react/jsx-runtime";
import SettingsIcon from "@mui/icons-material/Settings";
import { validateTidalLicense } from "../../base/index.js";
function Settings(props) {
  return /* @__PURE__ */ jsx(
    SettingsIcon,
    {
      "data-testid": "Settings",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Settings",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Settings.tidalIconMeta = {
  categories: "common,navigation",
  name: "Settings"
};
validateTidalLicense();
export {
  Settings
};
//# sourceMappingURL=Settings.js.map
